import type { HTMLAttributes, ReactNode } from 'react';
import { useDialogA11y, type UseDialogA11yOptions } from '../lib/useDialogA11y';

interface A11yDialogProps
  extends
    Omit<HTMLAttributes<HTMLDivElement>, 'role' | 'children'>,
    Pick<UseDialogA11yOptions, 'onClose' | 'closeOnEscape' | 'trapFocus' | 'lockScroll'> {
  children: ReactNode;
}

/** Tynd wrapper om useDialogA11y til steder, hvor hooket ikke kan kaldes pænt (fx i store komponenter). */
export function A11yDialog({
  onClose,
  closeOnEscape,
  trapFocus,
  lockScroll,
  children,
  ...divProps
}: A11yDialogProps) {
  const { ref } = useDialogA11y({ onClose, closeOnEscape, trapFocus, lockScroll });
  return (
    <div ref={ref} role="dialog" aria-modal="true" {...divProps}>
      {children}
    </div>
  );
}
